import React from 'react';
import ReactGA from 'react-ga';
import { BrowserRouter, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import TopMenu from './top-menu/TopMenu';
import Home from './Home';
import './App.scss';


const history = createBrowserHistory();

// Initialize google analytics page view tracking
history.listen(location => {
    ReactGA.set({ page: location.pathname }); // Update the user's current page
    ReactGA.pageview(location.pathname); // Record a pageview for the given page
});



function App() {
    return (
        <div className="App">
            <BrowserRouter >

                <TopMenu />
                <div className="content">
                    <Route path="/" exact component={Home} />
                </div>
            </BrowserRouter>
        </div>
    );
}

export default App;
